var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.65,11.16l-3.54-3.54c-.41-.41-1.07-.41-1.47,0-.41,.41-.41,1.07,0,1.47l1.9,1.9h-7.13c-.58,0-1.04,.47-1.04,1.04,0,.58,.47,1.04,1.04,1.04h7.06l-1.83,1.83c-.41,.41-.41,1.07,0,1.47,.41,.41,1.07,.41,1.47,0l3.55-3.55c.46-.46,.46-1.21,0-1.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,20H5c-.55,0-1-.42-1-.93V4.93c0-.51,.45-.93,1-.93h7c.55,0,1-.45,1-1s-.45-1-1-1H5c-1.66,0-3,1.31-3,2.93v14.15c0,1.61,1.35,2.93,3,2.93h7c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.9f83d43df17e9fc8ad435c81ca590c18.svg";
export { ForwardRef as ReactComponent };